export default __webpack_public_path__ + "static/media/upsells-empty.96e93d3c.svg";